import React from "react";
import { Page } from "react-pdf";
import { Rnd } from "react-rnd";
import { Button } from "@mui/material";
import { PAGE_WIDTH } from "./utils";

const PageCanvas = ({
  pageNumber,
  signatureUrl,
  placement,
  pageHeight,
  onRenderSuccess,
  onPlaceSignature,
  onRemoveSignature,
  onPlacementChange,
}) => {
  const containerHeight = pageHeight || PAGE_WIDTH * 1.414;

  return (
    <div className="pdf-signature-page">
      <div className="pdf-signature-page-toolbar">
        <span>Page {pageNumber}</span>
        {placement ? (
          <Button size="small" color="error" onClick={onRemoveSignature}>
            Remove signature
          </Button>
        ) : (
          <Button size="small" onClick={onPlaceSignature}>
            Place signature here
          </Button>
        )}
      </div>
      <div
        className="pdf-signature-page-canvas"
        style={{ width: PAGE_WIDTH, height: containerHeight }}
      >
        <Page
          pageNumber={pageNumber}
          width={PAGE_WIDTH}
          onRenderSuccess={({ width, height }) =>
            onRenderSuccess(pageNumber, { width, height })
          }
        />
        {placement && (
          <Rnd
            bounds="parent"
            lockAspectRatio
            size={{
              width: placement.wFrac * PAGE_WIDTH,
              height: placement.hFrac * containerHeight,
            }}
            position={{
              x: placement.xFrac * PAGE_WIDTH,
              y: placement.yFrac * containerHeight,
            }}
            onDragStop={(e, d) =>
              onPlacementChange(pageNumber, {
                xFrac: d.x / PAGE_WIDTH,
                yFrac: d.y / containerHeight,
              })
            }
            onResizeStop={(e, direction, ref, delta, position) =>
              onPlacementChange(pageNumber, {
                wFrac: ref.offsetWidth / PAGE_WIDTH,
                hFrac: ref.offsetHeight / containerHeight,
                xFrac: position.x / PAGE_WIDTH,
                yFrac: position.y / containerHeight,
              })
            }
            className="signature-overlay"
          >
            <img src={signatureUrl} alt="signature" draggable={false} />
          </Rnd>
        )}
      </div>
    </div>
  );
};

export default PageCanvas;
